// extracted by mini-css-extract-plugin
export default {"container":"_4e5IMLid3GzhqYrwbN14Xw"};